import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class Pricing extends Component {
  render() {
    const data = this.props.data || homedata.pricingtable;
    const tables = data.tables || [];
    const sectionTitle = data.sectiontitle || '料金プラン';

    return (
      <section id="pricing" className="p-80px-tb parallax bg-overlay opacity-5" style={{backgroundImage: 'url(' + process.env.PUBLIC_URL + '/assets/img/pricing-bg.jpg)'}}>
         <div className="container">
            <div className="row">
               <div className="col-sm-8 offset-sm-2">
                  <div className="section-title text-center m-50px-b">
                     <h2 className="text-white">{sectionTitle}</h2>
                  </div>
               </div>
            </div>
            <div className="row justify-content-md-center">
               { tables.map( ( tableData, i ) => {
                  return <div key={i} className="col-lg-4 col-md-6">
                     <div className={`single-pricing text-center m-10px-tb ${tableData.recommended ? 'featured-pricing' : ''}`}>
                        <div className="pricing-head p-60px-lr lg-p-30px-lr">
                           <div className="pricing-head-text">
                              <div className="package-price">
                                 <span className="price">{tableData.currency}{tableData.price}</span><span className="validity">{tableData.duration}</span>
                              </div>
                              <div className="package-name">
                                 <h5>{tableData.title}</h5>
                              </div>
                           </div>
                           <span className="wave"></span>
                           <span className="wave"></span>
                           <span className="wave"></span>
                        </div>
                        <div className="pricing-body p-60px-lr lg-p-30px-lr">
                           {tableData.description && <p className="text-muted">{tableData.description}</p>}
                           <ul>
                              {(tableData.features || []).map( ( feature, j  ) =>
                                 <li key={j}>{feature}</li>
                               )}
                           </ul>
                        </div>
                        <div className="pricing-footer p-60px-lr lg-p-30px-lr">
                           <a href={tableData.url} className="btn btn-default btn-filled animated-btn">
                              {tableData.btnLabel || 'このプランで相談する'}
                           </a>
                        </div>
                     </div>
                  </div>
               } ) }
            </div>
         </div>
      </section>
    );
  }
}

export default Pricing;
